<template>
  <div class="characteristic">
    <div class="contents industry-contents-title">
      <img
        :width="otherProductsAdvantages.aboutTitleWidth"
        :src="otherProductsAdvantages.productsTitle"
      />
    </div>
    <div class="contents haracteristic-contents" :class="{'haracteristic-contents-type':type==2}" :style="{height:height+'px'}"> 
      <div class="left">
        <p class="advantages-title">{{ otherProductsAdvantages.textTitle }}</p>
        <div
          v-for="(item, tindex) in otherProductsAdvantages.textList"
          :key="tindex"
          class="info"
        >
          <p v-if="isArrayList(item).length == 1">
            {{ item }}
          </p>
          <template v-else>
            <p class="mtitle">{{ isArrayList(item)[0] }}</p>
            <p>{{ isArrayList(item)[1] }}</p>
          </template>
        </div>
        <span class="more" @click="more()">了解更多</span>
      </div>
      <div class="right">
        <img
          :style="{ height: otherProductsAdvantages.height }"
          :src="otherProductsAdvantages.textImg"
        />
      </div>
    </div>
    <template v-if="otherProductsAdvantages.list&&otherProductsAdvantages.list.length>3">
      <advantages-swiper
        :swiperList="otherProductsAdvantages.list"
        :marginTopAndBottom="marginTopAndBottom"
      ></advantages-swiper>
    </template>
    <template v-if="otherProductsAdvantages.list&&otherProductsAdvantages.list.length==3">
      <advantages-list :otherProductsAdvantages="otherProductsAdvantages.list"></advantages-list>
    </template>
    
  </div>
</template>

<script>
import AdvantagesList from './AdvantagesList.vue';
import AdvantagesSwiper from "./AdvantagesSwiper.vue";
export default {
  components: { AdvantagesSwiper, AdvantagesList },
  props: {
    otherProductsAdvantages: {
      type: Object,
      default: function() {
        return {};
      }
    },
    type:{
        type: Number,
        default: 1
    },
    height:{
        type: Number,
        default: 342
    },
    marginTopAndBottom:{
      type: Number,
      default: 0
    }
  },

  methods: {
    more() {
      this.$emit("tabMoreItem");
    },
    isArrayList(val) {
      return val.split("|");
    }
  }
};
</script>
<style scoped>
/**产品特点 */
.haracteristic-contents {
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  width: 940px;
  height: 342px;
}
.haracteristic-contents .left {
  color: #666666;
  font-size: 16px;
  width: 470px;
}
.haracteristic-contents-type .left {
  width: 416px;
}

.haracteristic-contents .left .info {
  margin-bottom: 16px;
  line-height: 1.6;
}
.haracteristic-contents .left .info .mtitle {
  color: #333333;
  letter-spacing: 0.579597px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
}

.haracteristic-contents .right {
  height: 342px;
  width: 470px;
  text-align: center;
}

.haracteristic-contents-type .right {
  width: 346px;
}
.haracteristic-contents .right img {
  height: 272px;
  -webkit-box-reflect: below -2px -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(transparent),
      to(rgba(250, 250, 250, 0.3))
    );
}
.haracteristic-contents-type .right img {
    width: 100%;
    height: 215px;
}
.haracteristic-contents .more {
  font-size: 16px;
  width: 130px;
  height: 36px;
  line-height: 36px;
  color: #ffffff;
  display: inline-block;
  border-radius: 49px;
  background-color: #2655ae;
  text-align: center;
  cursor: pointer;
  margin-top: 21px;
}
.industry-contents-title {
  text-align: center;
  padding-top: 55px;
  margin-bottom: 60px;
}
.advantages-title {
  font-size: 24px;
  line-height: 35px;
  color: #333333;
  letter-spacing: 0.579597px;
}
</style>



// WEBPACK FOOTER //
// src/components/brand/OtherProductsAdvantages.vue